import { JWT } from '../interfaces';
import { LoginSessionJWT } from './session';
import { JWTSessionRefresher } from './session-refresher';
import { JWTLoginSessionStore } from './session-store';

export class JWTLoginSessionManager {
    private readonly store = new JWTLoginSessionStore();
    private readonly refresher = JWTSessionRefresher.getInstance();

    /**
     * Start a new login session.
     * This should be called right after the successful login.
     */
    public start(jwt: JWT) {
        this.store.write(jwt);
        this.refresher.start(true);
        return new LoginSessionJWT(jwt);
    }

    /**
     * Stop a current login session.
     * This should be called after logout from the application.
     */
    public clean(): void {
        this.store.clean();
        this.refresher.stop();
    }

    /**
     * Enable automatic session refresher.
     */
    public resumeAutoRefresh() {
        this.refresher.resume(false);
    }

    public forceSessionRefresh() {
        this.refresher.resume(true);
    }

    public setSessionRefreshErrorHandler(errorHandler?: () => void) {
        this.refresher.setFailHandler(errorHandler);
    }

    /**
     * Load a session from the local storage.
     */
    public load() {
        const jwt = this.store.read();
        return new LoginSessionJWT(jwt);
    }

    public isLoggedIn() {
        try {
            const session = this.load();
            return session.isActual();
        } catch {
            return false;
        }
    }
}
